import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { updateCarouselOrder, CAROUSEL_QUERY_KEY } from "./api";

interface UpdateCarouselOrderParams {
  venuePageId: string;
  itemIds: string[];
}

/**
 * Hook to update carousel item order (lightweight, for drag-and-drop)
 */
export function useUpdateCarouselOrder(): UseMutationResult<
  { success: boolean },
  Error,
  UpdateCarouselOrderParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ venuePageId, itemIds }: UpdateCarouselOrderParams) =>
      updateCarouselOrder(venuePageId, { itemIds }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [CAROUSEL_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
